"use strict";

const btnchange = document.querySelector(".btn--cta");
const utoBody = document.getElementById('uto');
const dystBody = document.getElementById('dyst');
const blackout = document.getElementById('blackout');

btnchange.addEventListener("click", (e) => {
    blackout.classList.toggle("blackout");
    setTimeout(() => {
        blackout.classList.toggle("blackout");
    }, 100);
    setTimeout(() => {
        blackout.classList.toggle("blackout");
    }, 50);
    setTimeout(() => {
        blackout.classList.toggle("blackout");
    }, 30);
    setTimeout(() => {
        blackout.classList.toggle("blackout");
    }, 120);
    setTimeout(() => {
        blackout.classList.toggle("blackout");
    }, 300);
    setTimeout(() => {
        blackout.classList.toggle("blackout");
    }, 60);
    setTimeout(() => {
        blackout.classList.toggle("blackout");
    }, 30);
    setTimeout(() => {
        utoBody.classList.add("hidden");
        dystBody.classList.remove("hidden");
        document.body.setAttribute("data-theme", "dyst");
        blackout.classList.remove("blackout");
        window.scrollTo({
            top: 0,
        });
    }, 100);
    
});

// glitch

